import React from 'react'
import { any } from 'prop-types'
import { datadogRum } from '@datadog/browser-rum'

import { GenericError } from 'pages/GenericError'

import { PrettyError } from './PrettyError'

const isDevelopment = process.env.NODE_ENV === 'development'

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null }

  static propTypes = {
    children: any,
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      error,
    }
  }

  componentDidCatch(error, errorInfo) {
    datadogRum.addError(error, errorInfo)
  }

  render() {
    const { hasError, error } = this.state
    const { children } = this.props

    if (!hasError) {
      return children
    }

    if (isDevelopment) {
      return <PrettyError stack={error.stack} />
    }

    return <GenericError />
  }
}

export { ErrorBoundary }
